import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseApi } from '../../../dtos/ResponseApi';
import { CargoResponse } from '../../../dtos/core/cargo/CargoResponse';
import { CreateCargoDto } from '../../../dtos/core/cargo/CreateCargoDto';

@Injectable({
  providedIn: 'root'
})
export class CargoService {
  private baseUrl = `${environment.apiUrl}/core/cargo`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<ResponseApi<CargoResponse[]>> {
    return this.http.get<ResponseApi<CargoResponse[]>>(this.baseUrl);
  }

  create(request: CreateCargoDto): Observable<ResponseApi<CargoResponse>> {
    return this.http.post<ResponseApi<CargoResponse>>(this.baseUrl, request);
  }
}
